export const initialState = {
  isFetching: false,
  items: [],
  data: {},
}

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)

export const setItems = (state, payload) => (
  { ...state, items: payload, isFetching: false }
)

export const update = (state, payload) => (
  { ...state, data: payload, isFetching: false }
)
